"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multi = void 0;
var reducer_1 = require("./reducer");
Object.defineProperty(exports, "multi", { enumerable: true, get: function () { return reducer_1.reducer; } });
